const AccessStatusEnum = {
  active: null,
  expired_docs: null,
  pending: null,
  rejected: null,
  blocked: null,
  partner_blocked: null,
  new_partner: null,
  end_of_life: null,
  failed_tests: null,
  to_be_offboarded: null,
  offboarded: null,
};

type TAccessStatus = keyof typeof AccessStatusEnum;

const WARNING_STATUSES: TAccessStatus[] = ['expired_docs', 'rejected', 'blocked', 'failed_tests'];

export type { TAccessStatus };
export { AccessStatusEnum, WARNING_STATUSES };
